
import React, { useState, useEffect } from "react";
import { Modal, Select, Button, Input, message } from "antd";
import "./PRSAssignDA.scss";
import API from "../../../api";
import urls from "../../../api/urls";

const PRSAssignDA = ({ isModalOpen, handleCancel, prsData, handleSuccess }) => {
  const [selectedDA, setSelectedDA] = useState(null);
  const [daOptions, setDaOptions] = useState([]);

  const handleSuccessApi = ()=> {
    handleSuccess();
  };

  // Reset selectedDA when modal closes
  useEffect(() => {
    if (!isModalOpen) {
      setSelectedDA(null);
    }
  }, [isModalOpen]);

  // Fetch DA list when modal opens
  useEffect(() => {
    if (isModalOpen && prsData?.prsNumber) {
      fetchDAList();
      setSelectedDA(null); // Reset selected DA when modal opens
    }
  }, [isModalOpen, prsData]);

  const fetchDAList = async () => {
    try {
      // const result = await API.Api(`${urls.PRS_DA_LIST}/${prsData?.prsNumber}`).get();
      const result = await API.Api(`${urls.PRS_DA_LIST}/${prsData?.prsNumber}`).getwithParams(prsData?.prsNumber, { kid: "1",  authtype: "jwt"});
      const response = result?.response?.data;
      
      if (response?.status === 200) {
        const formattedOptions = response.data.map(da => ({
          value: da._id,
          label: `${da.name} ${da.lastName} (${da.deliveryAgentId})`,
          ...da
        }));
        setDaOptions(formattedOptions);
      }
    } catch (error) {
      message.error("Failed to fetch DA list");
      console.error("Error fetching DA list:", error);
    }
  };

  const handleAssign = async () => {
    if (!selectedDA) {
      message.warning("Please select a DA");
      return;
    }

    try {
      const payload = {
        PRS_No: prsData?.prsNumber,
        DA_id: [selectedDA]
      };

      const result = await API.Api(urls.PRS_ASSIGN_DA).postCustomHeader(
        payload,
        {
          kid: "1",
          authtype: "jwt",
        }
      );

      const response = result?.response?.data;

      if (response?.status === 200) {
        message.success("DA assigned successfully");
        handleCancel();
        handleSuccessApi();
      } else {
        message.error(response?.message || "Failed to assign DA");
      }
    } catch (error) {
      message.error("Failed to assign DA");
      console.error("Error assigning DA:", error);
    }
  };

  return (
    <Modal
      title="Assign DA"
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      width={800}
      className="prs-assign-modal"
    >
      <div className="modal-content">
        <div
          className="form-row"
          style={{ display: "flex", flexDirection: "row", gap: "16px", width:"100%" }}
        >
          <div className="form-group" style={{ flex: "1" }}>
            <label>PRS No.</label>
            <Input
              type="text"
              value={prsData?.prsNumber}
              disabled
              className="form-control"
              style={{ width: "100%" }}
              title={prsData?.prsNumber || "PRS Number"}
            />
          </div>
          <div className="form-group" style={{ flex: "1" }}>
            <label>
              Select DA<span className="required">*</span>
            </label>
            <Select
              placeholder="Select DA"
              options={daOptions}
              onChange={(value) => setSelectedDA(value)}
              value={selectedDA}
              className="w-100"
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              styles={{
                container: (provided) => ({ ...provided, width: "100%" }),
              }}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Seller Name</label>
            <Input
              type="text"
              value={prsData?.sellerInfo?.name}
              disabled
              className="form-control"
              title={prsData?.sellerInfo?.name}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Pickup From (Seller Address)</label>
            <Input
              type="text"
              value={prsData?.pickupInfo?.address1}
              disabled
              className="form-control"
              title={prsData?.pickupInfo?.address1}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Hub Name</label>
            <Input
              type="text"
              value={prsData?.dropInfo?.name}
              disabled
              className="form-control"
              title={prsData?.dropInfo?.name}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Drop At (Hub Address)</label>
            <Input
              type="text"
              value={prsData?.dropInfo?.address1}
              disabled
              className="form-control"
              title={prsData?.dropInfo?.address1}
            />
          </div>
        </div>

        <div className="button-group">
          <Button onClick={handleCancel}>CANCEL</Button>
          <Button type="primary" onClick={handleAssign} disabled={!selectedDA}>
            ASSIGN
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PRSAssignDA;
